// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Routing
import { SlideRoutingModule } from './slide-routing.module';
// Modules
import { MedsurfViewerCommonModule } from '../common/medsurf-viewer-common.module';
// Components
import { AudioComponent } from './main/audio/audio.component';
import { CopyrightComponent } from './sidebar/copyright/copyright.component';
import { FooterComponent } from './footer/footer.component';
import { FreetextQuestionComponent } from './sidebar/questions/question-types/freetext-question/freetext-question.component';
import { ImageComponent } from './main/image/image.component';
import { IndicationQuestionComponent } from './sidebar/questions/question-types/indication-question/indication-question.component';
import { InteractiveAreaComponent } from './sidebar/interactive-area/interactive-area.component';
import { KPrimQuestionComponent } from './sidebar/questions/question-types/k-prim-question/k-prim-question.component';
import { MappingQuestionComponent } from './sidebar/questions/question-types/mapping-question/mapping-question.component';
import { PoiComponent } from './sidebar/poi/poi.component';
import { PrintComponent } from './print/print.component';
import { QuestionsComponent } from './sidebar/questions/questions.component';
import { QuestionFooterComponent } from './sidebar/questions/question-footer/question-footer.component';
import { QuestionHeaderComponent } from './sidebar/questions/question-header/question-header.component';
import { SequenceControlComponent } from './main/sequenceControl/sequenceControl.component';
import { ShortcutsComponent } from './main/shortcuts/shortcuts.component';
import { SingleChoiceQuestionComponent } from './sidebar/questions/question-types/single-choice-question/single-choice-question.component';
import { SlideComponent } from './slide.component';
import { SlideMainComponent } from './main/slide-main.component';
import { SlideHeaderComponent } from './header/slide-header.component';
import { SlideSidebarComponent } from './sidebar/slide-sidebar.component';
import { SliderComponent } from './footer/slider/slider.component';
import { TextComponent } from './sidebar/text/text.component';
import { TrainingSliderComponent } from './footer/training-slider/training-slider.component';
import { VideoComponent } from './main/video/video.component';
import { FlatDesignModule } from '@medsurf/flat-designs';

/**
 * Slide Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    RouterModule,
    // Bootstrap
    NgbModule,
    // Translate
    TranslateModule.forChild(),
    // Routing
    SlideRoutingModule,
    // Modules
    MedsurfViewerCommonModule,
    FlatDesignModule,
  ],
  declarations: [
    // Components
    AudioComponent,
    CopyrightComponent,
    FooterComponent,
    FreetextQuestionComponent,
    ImageComponent,
    IndicationQuestionComponent,
    InteractiveAreaComponent,
    KPrimQuestionComponent,
    MappingQuestionComponent,
    PoiComponent,
    PrintComponent,
    QuestionsComponent,
    QuestionFooterComponent,
    QuestionHeaderComponent,
    SequenceControlComponent,
    ShortcutsComponent,
    SingleChoiceQuestionComponent,
    SlideComponent,
    SlideMainComponent,
    SlideHeaderComponent,
    SlideSidebarComponent,
    SliderComponent,
    TextComponent,
    TrainingSliderComponent,
    VideoComponent,
  ],
  exports: [
    // Components
    SlideComponent,
    TextComponent,
  ]
})
export class SlideModule {
}
